import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Stack } from '@mui/material';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import { TrashIcon } from '../icons/TrashIcon';
import { Confirmation } from '../modals/common';
import { messageUtility } from '../../utilities/messageUtility';
import { ATTACH_DOCUMENT_TYPE_COMPANY } from '../../utilities/constants';

/**
 * ファイル（画像、PDF）添付機能
 * @param companyDocuments {object}
 * @param documentCodes {object}
 * @param events {object}
 * @param itemName {string}
 * @param indexId {string} 未定義許容
 * @param index {number} 未定義許容
 * @param keyName {string} 未定義許容
 * @param requireConfirm {boolean}
 */
export default class AttachDocument extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      file_typeS: '',
      files: [],
      invalidSize: false,
      invalidType: false,
      invalidName: false,
      isInside: true, // テキストは見切れるかどうか
      isShowConfirmDialog: false,
    };
    this.updateCategory = this.updateCategory.bind(this);
    this.checkTextPlacement = this.checkTextPlacement.bind(this);
    this.fileInput = React.createRef();
    this.parent = React.createRef();
    this.textElement = React.createRef();
    this.typebox = React.createRef();
  }

  updateCategory(e) {
    this.setState({ file_typeS: e.target.value });
  }
  // BLDE_V2-49631 ファイル選択ボタン＋最大50MBテキストは見切れるなら
  // レイアウトが変わる
  checkTextPlacement() {
    if (this.parent.current && this.textElement.current) {
      const parentRect = this.parent.current.getBoundingClientRect();
      const elementRect = this.textElement.current.getBoundingClientRect();
      const typeboxrect = this.typebox.current.getBoundingClientRect();
      const rightGap = parentRect.right - typeboxrect.right;
      const textLength = elementRect.right - elementRect.left;
      const textMargin = textLength + 16;
      if (this.state.isInside && textMargin >= rightGap) {
        this.setState({ isInside: false });
      }

      if (!this.state.isInside && rightGap >= textMargin) {
        this.setState({ isInside: true });
      }
    }
  }

  componentDidMount() {
    if (this.props.documentCodes) {
      const docType = this.props.documentCodes[0];
      this.setState({ file_typeS: docType ? docType.file_typeS : '' });
    }
    this.checkTextPlacement();
    // BLDE_V2-50116 ファイルアップロードボックスの幅を変更すれば、テキストは見切れるかどうか確認が行う。
    if (this.parent.current) {
      this.observer = new window.ResizeObserver(() => {
        this.checkTextPlacement();
      });
      this.observer.observe(this.parent.current);
    }
  }
  componentWillUnmount() {
    if (this.observer && this.parent.current) {
      this.observer.unobserve(this.parent.current);
    }
  }
  componentDidUpdate(prevProps) {
    // BLDE_V2-36772 プルダウンの値が選択済みの場合、勝手に値を初期化しないよう条件追加
    if (
      prevProps.documentCodes !== this.props.documentCodes &&
      this.state.file_typeS == ''
    ) {
      this.setState({
        file_typeS: this.props.documentCodes[0]
          ? this.props.documentCodes[0].file_typeS
          : '',
      });
    }
    if (prevProps.companyDocuments !== this.props.companyDocuments) {
      this.setState({
        files: this.props.companyDocuments,
        invalidType: _.some(this.props.companyDocuments, document => {
          return document.invalidType === true;
        }),
        invalidSize: _.some(this.props.companyDocuments, document => {
          return document.invalidSize === true;
        }),
        invalidName: _.some(this.props.companyDocuments, document => {
          return document.invalidName === true;
        }),
      });
    }
  }

  handleVisibleConfirmDialog = (isShowConfirmDialog) => {
    this.setState({ isShowConfirmDialog });
  }

  render() {
    const {
      companyDocuments,
      documentCodes,
      events,
      itemName = '',
      readOnly,
      indexId = '',
      styleWide = false,
      isFormListDefault = false,
      deleteOnly,
    } = this.props;

    return (
      <div
        className={`attach-document ${
          !styleWide ? '' : 'attach-document--padding-none'
        }`}
      >
        {itemName === '' ? null : (
          <p className='attach-document__label'>{itemName}</p>
        )}
        <div
          className={`attach-document__files ${
            !styleWide ? '' : 'attach-document__files--wide'
          }`}
        >
          {companyDocuments.length > 0 && (
            <ul className='attach-document__file-list'>
              {_.map(companyDocuments, document => {
                // 種別名をdocumentCodesから探し出す
                const documentType = _.find(documentCodes, code => {
                  return code.file_typeS === document.file_typeS;
                });

                let documentDate = '----/--/-- --:--';
                if (_.isUndefined(document.created_at)) {
                  // console.error(
                  //   'AttachDocument.jsx render document.created_at is undefined'
                  // );
                } else {
                  const documentDateCreatedAt = moment(document.created_at);
                  if (documentDateCreatedAt.isValid() === false) {
                    console.error(
                      'AttachDocument.jsx render document.created_at is moment isValid = false'
                    );
                  } else {
                    documentDate = documentDateCreatedAt.format(
                      'YYYY/MM/DD HH:mm'
                    );
                  }
                }
                return (
                  <li
                    key={`file-item__${
                      document.id
                        ? document.id
                        : document.temp_file_key
                        ? document.temp_file_key
                        : _.random()
                    }`}
                    className={
                      (document.invalidType || document.invalidSize || document.invalidName
                        ? 'attach-document__file-item attach-document__file-item--invalid'
                        : 'attach-document__file-item') +
                      (!styleWide
                        ? ''
                        : ' attach-document__file-item--padding-left-small')
                    }
                  >
                    <span className='attach-document__file-item-type'>
                      {documentType ? documentType.file_typeS_name : ''}
                    </span>
                    {readOnly ? (
                      <span>
                        <span
                          className='attach-document__file-item-name attach-document__file-item-name--linked'
                          onClick={() => {
                            events.download(document.id);
                          }}
                        >
                          {document.file_name}
                        </span>
                        <span className='attach-document__file-item-date'>
                          ({documentDate})
                        </span>
                      </span>
                    ) : (
                      <span className='attach-document__file-item-details'>
                        {document.id &&
                        typeof events.download === 'function' ? (
                          <span
                            className='attach-document__file-item-name attach-document__file-item-name--linked'
                            onClick={() => {
                              events.download(document.id);
                            }}
                          >
                            {document.file_name}
                          </span>
                        ) : (
                          <span className='attach-document__file-item-name'>
                            {document.file_name}
                          </span>
                        )}
                        <button
                          className='attach-document__file-close icon__btn form-list__element--btn_delete'
                          onClick={() => {
                            events.deleteFile(
                              document,
                              this.props.index,
                              this.props.keyName
                            );
                          }}
                        >
                          {isFormListDefault ? (
                            <TrashIcon className='icon--2_4x attach-document__trash-icon' />
                          ) : (
                            <i className='icon-close' />
                          )}
                        </button>
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          )}
          {!readOnly && !deleteOnly && (
            <React.Fragment>
              {(this.state.invalidName || this.state.invalidSize || this.state.invalidType) && (
                <div className='attach-document__error'>
                  {this.state.invalidName && (
                    <p className='attach-document__error-text'>
                      {!this.props.isFormListDefault && (
                        <i className='icon-error' />
                      )}
                      拡張子だけのファイルは登録できません。ファイルに名前を付けてから登録してください。
                    </p>
                  )}
                  {this.state.invalidSize && (
                    <p className='attach-document__error-text'>
                      {!this.props.isFormListDefault && (
                        <i className='icon-error' />
                      )}
                      アップロードできるファイルサイズを超えています。50MB以下にしてください。
                    </p>
                  )}
                  {this.state.invalidType && (
                    <p className='attach-document__error-text'>
                      {!this.props.isFormListDefault && (
                        <i className='icon-error' />
                      )}
                      画像(jpg,jpeg,png,bmp,tiff,tif,gif)、PDF(pdf)以外のファイルが選択されています。
                    </p>
                  )}
                </div>
              )}
              <div
                ref={this.parent}
                className={
                  this.state.isInside
                    ? 'attach-document__upload'
                    : 'attach-document__upload attach-document__upload--small-screen'
                }
              >
                <div
                  ref={this.typebox}
                  className={
                    this.state.isInside
                      ? 'attach-document__type-box'
                      : 'attach-document__type-box attach-document__type-box--small-screen'
                  }
                >
                  <label htmlFor='attach-document-type'>種別</label>
                  <select
                    name='type'
                    onChange={this.updateCategory}
                    title='種別を選択'
                    value={this.state.file_typeS}
                  >
                    <option value='' disabled>
                      種別を選択
                    </option>
                    {_.map(documentCodes, docType => {
                      if (
                        docType.file_typeL ===
                          ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN &&
                        docType.file_typeS === '010'
                      ) {
                        return null;
                      }
                      return (
                        <option
                          key={`document-type__${docType.file_typeS}`}
                          value={docType.file_typeS}
                        >
                          {docType.file_typeS_name}
                        </option>
                      );
                    })}
                  </select>
                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon form-list__attach-document-arrow-icon' />
                </div>
                <div
                  ref={this.textElement}
                  className={
                    this.state.isInside
                      ? 'attach-document__select-file'
                      : 'attach-document__select-file attach-document__select-file--small-screen'
                  }
                >
                  <input
                    id={`fileSelect${itemName}${indexId}${_.toString(
                      this.props.index
                    )}`}
                    disabled={this.state.file_typeS === ''}
                    name='file_name'
                    type='file'
                    accept='image/jpg, image/jpeg, image/png, image/bmp, image/tiff, image/tif, image/gif, application/pdf, .tif, .tiff, .bmp'
                    onChange={async () => {
                      events.uploadFile(
                        this.fileInput.current.files[0],
                        this.props.documentCodes[0].file_typeL,
                        this.state.file_typeS,
                        this.props.index,
                        this.props.keyName
                      );
                      this.fileInput.current.value = '';
                    }}
                    style={{ display: 'none' }}
                    ref={this.fileInput}
                  />
                  <label
                    className='btn input-file'
                    htmlFor={`fileSelect${itemName}${indexId}${_.toString(
                      this.props.index
                    )}`}
                    disabled={this.state.file_typeS === ''}
                    onClick={e => {
                      if (this.props.requireConfirm) {
                        e.preventDefault();
                        this.handleVisibleConfirmDialog(true);
                      }
                    }}
                  >
                    ファイル選択
                  </label>
                  <p className='attach-document__help'>最大50MB</p>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        {this.state.isShowConfirmDialog && (
          <AttachDocumentConfirmDialog
            onClose={() => this.handleVisibleConfirmDialog(false)}
            onConfirm={() => {
              this.handleVisibleConfirmDialog(false);
              this.fileInput.current.click();
            }}
          />
        )}
      </div>
    );
  }
}

AttachDocument.defaultProps = {
  requireConfirm: false,
};

const AttachDocumentConfirmDialog = ({ onClose, onConfirm }) => {
  const [checked, setChecked] = useState(false);

  const renderMessage = () => {
    return (
      <div>
        本サービスにマイナンバーカード（表面・裏面）を登録しないでください。マイナンバーの保有者本人であっても、法令に定める場合を除き、マイナンバー情報を提供することはできません。（番号法第１９条）
        <br />
        <br />
        万が一、マイナンバーカードの登録が発見された場合は、リバスタにて登録データの削除をする場合がございます。
        <Stack alignItems='center' sx={{ marginTop: '16px' }}>
          <label className='checkbox'>
            <input
              name='checkbox'
              type='checkbox'
              disabled={false}
              checked={checked}
              onChange={() => {
                setChecked(prevChecked => !prevChecked);
              }}
            />
            <i className='i-square i-3x' />
            確認しました
          </label>
        </Stack>
      </div>
    );
  };
  return (
    <Confirmation
      visible={true}
      title={messageUtility.getMessage('I-000-264')}
      message={renderMessage()}
      confirmButtonText={messageUtility.getMessage('I-000-080')}
      cancelButtonText={messageUtility.getMessage('I-000-017')}
      onConfirm={onConfirm}
      onCancel={onClose}
      disabledConfirmButton={!checked}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/AttachDocument.jsx